import { render, staticRenderFns } from "./ExpendableSideNav.vue?vue&type=template&id=2ae12110&scoped=true"
import script from "./ExpendableSideNav.vue?vue&type=script&lang=js"
export * from "./ExpendableSideNav.vue?vue&type=script&lang=js"
import style0 from "./ExpendableSideNav.vue?vue&type=style&index=0&id=2ae12110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae12110",
  null
  
)

export default component.exports